import { motion } from "framer-motion";

import img1 from "./assets/shift.png";
import img2 from "./assets/costt.png";
import img3 from "./assets/workforcee.png";
import bgPattern from "./assets/bg-patternn.svg";


const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const WorkforceJiviews = () => {
  return (
    <section className="relative w-full py-20 font-epilogue bg-[#F5F7F9] overflow-hidden">
      
      <img
        src={bgPattern}
        alt="Background Pattern"
        className="absolute inset-0 w-full h-full object-cover opacity-55 pointer-events-none z-0"
      />

      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-12 z-10">
       
        <motion.h2
          className="text-3xl lg:text-4xl font-semibold text-center mb-16 text-gray-900"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          Transform Workforce Management with JIVIEWS
        </motion.h2>

        <div className="relative flex flex-col gap-24">
        
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <motion.div
              className="flex flex-col text-left md:pr-12"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Intelligent Shift Planning
              </h3>
              <p className="text-gray-600 leading-relaxed text-base">
                JIVIEWS Scheduler matches staff to tasks by analyzing demand,
                skills, and availability for optimized shifts.
              </p>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.05, y: -5 }}
              transition={{ type: "spring", stiffness: 200, damping: 10 }}
              className="overflow-hidden rounded-2xl shadow-md"
            >
              <motion.img
                src={img1}
                alt="Faster Turnaround"
                className="rounded-2xl w-full object-cover transition-transform duration-500 hover:scale-110"
                initial={{ opacity: 0, x: 80 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, ease: "easeOut" }}
              />
            </motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <motion.div
              whileHover={{ scale: 1.05, y: -5 }}
              transition={{ type: "spring", stiffness: 200, damping: 10 }}
              className="overflow-hidden rounded-2xl shadow-md order-2 md:order-1"
            >
              <motion.img
                src={img2}
                alt="Fuel Savings"
                className="rounded-2xl w-full object-cover transition-transform duration-500 hover:scale-110"
                initial={{ opacity: 0, x: -80 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, ease: "easeOut" }}
              />
            </motion.div>

            <motion.div
              className="flex flex-col text-left md:pl-12 order-1 md:order-2"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Enhanced Efficiency & Cost
              </h3>
              <p className="text-gray-600 leading-relaxed text-base">
                JIVIEWS optimizes workforce using real-time data, reducing costs,
                errors, idle time, and enhancing resource efficiency.
              </p>
            </motion.div>
          </div>

         
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <motion.div
              className="flex flex-col text-left md:pr-12"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Empowered Workforce
              </h3>
              <p className="text-gray-600 leading-relaxed text-base">
                JIVIEWS empowers employees with autonomy and tools to manage
                their schedules, driving engagement and productivity.
              </p>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.05, y: -5 }}
              transition={{ type: "spring", stiffness: 200, damping: 10 }}
              className="overflow-hidden rounded-2xl shadow-md"
            >
              <motion.img
                src={img3}
                alt="Less Downtime"
                className="rounded-2xl w-full object-cover transition-transform duration-500 hover:scale-110"
                initial={{ opacity: 0, x: 80 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, ease: "easeOut" }}
              />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkforceJiviews;
